import {
  doc,
  getDoc,
  onSnapshot,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

const COLLECTION = "legalPages";

export function subscribeLegalPage(slug, callback) {
  return onSnapshot(
    doc(db, COLLECTION, slug),
    (snap) => {
      callback(snap.exists() ? { id: snap.id, ...snap.data() } : null);
    },
    () => {
      // Draft pages are denied by security rules for signed-out readers —
      // treat that the same as "not published yet" rather than hanging.
      callback(null);
    }
  );
}

export async function fetchLegalPage(slug) {
  const snap = await getDoc(doc(db, COLLECTION, slug));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

// Archives the current doc into legalPages/{slug}/versions/{version} before
// overwriting it, so prior published/draft text is never lost.
export async function saveLegalPage(slug, { title, content, status, effectiveDate }) {
  const ref = doc(db, COLLECTION, slug);
  const existing = await getDoc(ref);

  let nextVersion = 1;
  if (existing.exists()) {
    const prev = existing.data();
    nextVersion = (prev.version || 0) + 1;
    await setDoc(doc(db, COLLECTION, slug, "versions", String(prev.version || 0)), {
      ...prev,
      archivedAt: serverTimestamp(),
    });
  }

  await setDoc(ref, {
    title,
    slug,
    content,
    status,
    effectiveDate: effectiveDate || null,
    version: nextVersion,
    updatedAt: serverTimestamp(),
    createdAt: existing.exists() ? existing.data().createdAt : serverTimestamp(),
  });
}
